
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorWrapper',
  props: {
    showElem: { type: Function }
  }
})
